import React from 'react';
import { Card, Flex, theme } from 'antd';

interface FilterBarProps {
  /** Search box, selects, date ranges… Each child should set a `minWidth`/`flex` and never a fixed width. */
  children: React.ReactNode;
  /** Right-aligned controls such as Refresh or Clear filters. */
  actions?: React.ReactNode;
}

/**
 * Card that holds a list page's search and filter controls. Controls wrap to new lines
 * on narrow screens instead of overflowing the page.
 */
export function FilterBar({ children, actions }: FilterBarProps) {
  const { token } = theme.useToken();

  return (
    <Card
      style={{ marginBottom: token.marginMD }}
      styles={{ body: { padding: `${token.paddingSM}px ${token.paddingMD}px` } }}
    >
      <Flex wrap="wrap" align="center" gap={token.marginSM} justify="space-between">
        <Flex wrap="wrap" align="center" gap={token.marginSM} style={{ flex: '1 1 260px', minWidth: 0 }}>
          {children}
        </Flex>
        {actions ? (
          <Flex wrap="wrap" align="center" gap={token.marginXS}>
            {actions}
          </Flex>
        ) : null}
      </Flex>
    </Card>
  );
}

export default FilterBar;
